import { render, staticRenderFns } from "./RealEstateStatusView.vue?vue&type=template&id=1a38553d&scoped=true&"
import script from "./RealEstateStatusView.vue?vue&type=script&lang=js&"
export * from "./RealEstateStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38553d",
  null
  
)

export default component.exports